import {BaseModel} from '../_base/crud';

export class ScheduleModel extends BaseModel {
    id: number;
    /**
     * サーバーから来るjsonには含まれない
     */
    projectId: number | undefined;
    /**
     * サーバーから来るjsonには含まれない
     */
    projectEditId: number | undefined;
    subject: string;
    color: string;
    fromDate: string;
    toDate: string;
    timeOfDelivery: TimeOfDelivery | undefined;
    status: number;
    priority: number;
    preferredTimePriority?: number;

    clear(): void {
        this.id = 0;
        this.projectId = 0;
        this.projectEditId = 0;
        this.subject = '';
        this.color = '';
        this.fromDate = '';
        this.toDate = '';
        this.timeOfDelivery = undefined;
        this.status = 0;
        this.priority = 0;
    }
}

export const studio55Logo = 'data:image/png;base64,' +
    'iVBORw0KGgoAAAANSUhEUgAAAMcAAAAoCAYAAABKF+6RAA' +
    'AAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccll' +
    'PAAACyFJREFUeNrsXQuQllUZfndZLgviAiXiYkguGkFIQB' +
    'YghCXg4mppGVOTlyx1dMrLjOGlnOyOkzPdzUlspEGdkTIM' +
    'XVggV8FVdE28ha4iXtC8ICgrBMtt7bzzPd9wOHsu7/dfmP' +
    '3wPDPvsP//n/8733fO+7y3c85PxYQJEygiwoPeSjYpOaRE' +
    '15ur5Ad5ePCqOPe5RoWSASW83nYlO433ppaQGIzmvAxuJE' +
    'e+cYKSB0t4vZlKVhjv1Zfw+h1KHsrL4FZG/co1Sqm47DFa' +
    'HIQpFVYr2RHJEXEgMKvMinukkjEl7ONfeRrcSI78YrCST5' +
    'dZcetLfM/3R3JEHAjMLPH82RT35MB37kFRQCqr8zTAMSE/' +
    'eEMqziG2C6/1PyWtxns9lMw4mMKkSI4PByoFinuVkt8V0c' +
    'ckJTWBNs2RHBHdDbxye1igzX1F9hEKqd5SslZ7zWshRykZ' +
    'pOQ9Jeuo65pJ7ixQRP4QSpTfNhS3HGEb5ygfoB2vjWxW8h' +
    '8lq5Q8o2SLkjuVHB09R8SBRMiqN0NxU4xQ8jElvZRsVNJG' +
    '/vUGroSNC/TBRGjy3EsfJbOVnIQQbV0kR0S5MVDJRAE5+i' +
    'm5TMl3LNabiXGHkqsp2TdlYoYgqriGZNtKPqLkFyBKJEdE' +
    'WTGdkkqSD9uUPAdvYUM1SDMRVn1rxpCKKNt+q5NizhHRHf' +
    'INDqfme4ihY7SSCy06MaPE9zwokiOiO5CDF9t6Z7jeicbr' +
    '8cg5QnhMyQ3CXKIzJuQR5Qbvc6ot8TUHZCQf436020XJLt' +
    'u7A+3fiJ4jotyQ5AJspW9Vcp0j2Taxx3h9suA7vwIxpAZ2' +
    'XR4HO3qOgyukYnxfyW/wd3+8llp1Dse43Pu4pz0v7Okr48' +
    'cJ7unJSI6IcoKrQ5MDbVhxb9Fe9xJc9wXj+5/LeF9TBW0e' +
    'OpjI0QMPfbySUZTU1vvhs3ZKtgfwIhBvPDO3EHy3wHvhVd' +
    '35lNTDP+5ocyMlZcrLHUnn+0puwt9cppxmfL4XbfTXmyCv' +
    'Knndcs1DlVzsCRf+YXl/KCUl17GUnIkYgES5A8/JK8jLKF' +
    'mMk+ITFD71xxZaL8uOFVz3iSL0h0vCkwJtuHq2Ko/kqDB+' +
    'YIEtzZVKvqfkcOE1mCDfgIKdrmRRgffCSn0JJSu4ttLfBk' +
    'r27oykpIZvw99o32LTItxPFjyv5KeULJCl+JqShY72vBB2' +
    'vfb6s0p+RkkptELQ31IlZ1Oy9aLU6AMj1ieguIOFuYkNbA' +
    'BWBNo8LSRpt07I2VssxuQebkna3vUM0AX4u6GIe2mEFRrk' +
    '+TzUR6Nm0aYXcA9snW8zrOFpgv4YVyh5mJJzFiYx3qH9t3' +
    'PoCfZfyzS3kwPEIHj9TUX08UVBm/sop9DDqrMclYotsIgv' +
    'InkbYmmTVi52wHqn+CrZK2Ls+psMC9YMYrpwd4AcnbDE6a' +
    'S5VnBZGe+lZGvFFJs3VTKckoM5PTz9bUB4lCbKNzi8BXvD' +
    'P0JJbMr0+TLNrWRVWk+sz6TwFg/2EvOK6CO35DjfEzatAy' +
    'lcoVZ6UOZS7b0xCEls4BNk37S871JEzjNWwqu4EsBHEZKF' +
    'vAsnrC0grgup0ks8GYFoNmK0oz/+7JOO67xSprmVWHX9sN' +
    'J5Sk4RePcUnEeFfvRsT8Z84xrLfbOu/J6SX1r5sfHZHORZ' +
    'nH/+k/bfVjNXI2YvEP8UhHi1uP92eE7W3ztxDSs5XJvZuH' +
    'rBZ5VfI/cvUTySQdHNQU5Rh3zCNYk7odCuIsJiQd/vwiNU' +
    'eCy2fk5B8gyDPSHcciThvOp8hKPNwwKl4XWF0C5Z3tz3AP' +
    '6uQTHFh72a4lYJq076UdppFN7j1WoUQLz5L3Jdc5HzZvw7' +
    '2zLO9SDHNCPq4UjkXPzNpFrgKPLUQOqQN/9JLyjpirbZ4R' +
    'l4j84auNQ/KFlCsu0ADZ5JaSqQTJI27LGGOdo0of/x5F5p' +
    'XqblB67+dmhWabaHsJL7Xi7w7hdRsmbhw/lGqBZS3MdgOQ' +
    'nEC13/ZYSSeq4ZQlMGrzHOMie7tfGxjeGJKIiYn61BCjAU' +
    '89lP+6wDEcEw01OYxl/PBy6lrqulOqtnwsW1gZW+1fVBnh' +
    'Lfakdy3+CpqCzBZNcL4v9SkWwYuX+Wppn2nYf4iiAHcvW3' +
    'W5CwfkaguOspKUVnUVw9F5gkaG+GR5LNiY0ZyGEboxYQeC' +
    'Ssu63oUGX5bqr05xrESO+JvY3tENbrLnJwuXIUEtY9noc4' +
    'hpL1iBZPqFDvsVy2ATuEuq5JpHgCVkAa/0s8lk9Zl2cgUI' +
    '0jqU8t80aEXa4Qp0Wz3i5Iwp2VBeQbSw2rnYUcw1HZ8+Et' +
    'yraG0uAZZ1dJvj9y1zrH985y5LtppdDEA66cg5B4f4uSWj' +
    '8fhDmH3Ds8JyEWPrsE+cZ0Tz9ZrL3EY0mVVdIfe9OegTaz' +
    'PF5WYlmzWnUOJT4VaJ/mXimOFfTxlPa3ZI/XXWQvX9vgmp' +
    'PFgrkwK5xvgJR1liKI7s2XWippC01yjHFMwIOoDswFSWwY' +
    'bXlPGv6YnqbQUEiP/yUeS6Ks1R7r+4wWe88qMoSTLJhKrL' +
    'q+PUOycTDNvVIcGWjPSvWsKzZ34NYMXsM2J20w1jaDt1eb' +
    'Z/PcyhKQssHjzRm/Dd0Uk+NKh/tpRJbPcdupjpDmNct7Jw' +
    'jDHwk5NuKBfPH/Mi3+l1j7L3na3KOFJdWCZ5jhMQJr4A1d' +
    'isRx70uB+entKS6k2IqcIws5FlqqNiFUY5w5BwqVfHnOHi' +
    '9RSGUavJ2YpzMD83O65zM+4GWWobng9HeTHFMDlQZW9IEe' +
    'xTThU757Le/x5B/laL8CVusMwUT39JBsPSz+EA+BWFnTTX' +
    'i+VfE02av1WNxVGnlcijdfoDS1FD5WsFYLX6oEyfhGWFcd' +
    '2wIEqYSy8/aaL5B/QyPfy5wMxOjpMCAuz7sSYiMHE4fL/n' +
    '0c0VAjikvXWSpjd9k8x1DPTXPY9ENyL3AtyJBvbHNUZkZ4' +
    'Bo5/iY/XWC7xlBfTh5ri8Vhca+cV7C97cpu/aJW50zyK1a' +
    'oZDfKEejx21zo+ZxLeIlAcyTntdFNjqpShI6k3ofBg5hND' +
    'A98bDgnhekuBwIcpFmK2I/+zheiN8EyuwsQ26Iy5dWYLcp' +
    'GpFmK8AlKN0iKGTibHI46Ky689D9SBRNw8mC9ZyDPRivDM' +
    'dub5Qup6xjnFs/AouwQh1bhA7M5jME9rW+up8HRq/a92WK' +
    'gLaN9+M1v17QwQPwTJvqeRiM/3YHJ92IAiiok/C0IlCRbA' +
    'mGaBLfxZDgLbDB6T47943iqHt+mwXJO93Y2WUJh18mIYzX' +
    '9r5Hi0EhM1j2T/b8Lb6GCMFp8XU6VKPcoUDKzkHjg8ugxK' +
    '/IKwbxt2YzDmIMfYmfEZOpGL3YxnCCW0TKRvU7JP7VXhPf' +
    'J4vylod6yAGLtQidzuqArdVgQpOEH+EfLTDzJ+tyFDSNWG' +
    'ELnDUdhp1NpdaxigviDBCI1AC5B7NFnyzEZ9y3pfTNxIlN' +
    'b6YtK3wuI8jQTS9/CcO3zU8VmbwFrygs1YlCIHQrbjPl5E' +
    'XrDB8j0OK8YLJ4NJwFu539G8jo6jPTnWWodV6odS5GiECI' +
    'cilNuK535Kq5JkxU+geFSk8rLi3u5pwyHMVbD8fTNcm/Or' +
    'q6mwX1CvdHj05zDvI4yQ6z2tiFFH+59/76Su6yr8HBOhlz' +
    'XwDpuhS62GoRhihJbrK+J/mNntUY2QdHKB3+c1jfNo/71n' +
    'PvCPsH2dkvKquRVnLzwZH3Tj8vEiKv5nR7stIjnyAfZMv6' +
    'Rkj1Uv4XfYS/Naw88RnhWDGkQM73+YBj2SI184Alady6m8' +
    '+ssbRfsjf9qMwgaHv82Iv9vjkBWO/wswAO81cJ95PVSXAAAAAElFTkSuQmCC';

export const PREFFERED_TIME_PRIORITIES = {
    '10..12': 1,
    '12..16': 2,
    '16..19': 3,
    '19..24': 4,
    '10': 5,
    '11': 6,
    '12': 7,
    '13': 8,
    '14': 9,
    '15': 10,
    '16': 11,
    '17': 12,
    '18': 13,
    '19': 14,
    '20': 15,
    '21': 16,
    '22': 17,
    '23': 18,
    '24': 19
} as const;
    
export type TimeOfDelivery = keyof typeof PREFFERED_TIME_PRIORITIES;